import { Upload, UploadOptions } from "@maysoft/tus-js-client"

import Global from "../../commons/global";
import Helpers from "../../commons/helpers";
import { ASSET_API_URL } from "../../constants/constants";

export interface ResumableUploadRequest {
    folderPath?: string,
    processingStatus: string,
    accessMode: string,
    tenantCode: string,
    serviceCode: string
}

const ResumableUploadService = {
    upload(file: File, request: ResumableUploadRequest, options: UploadOptions) {
        const authorization = Global.axios.defaults.headers.common["Authorization"].toString();
        return new Upload(file, {
            endpoint: Helpers.handleUrlJoin(ASSET_API_URL, "/TusFile"),
            chunkSize: options.chunkSize || 5 * 1024 * 1024,
            removeFingerprintOnSuccess: options.removeFingerprintOnSuccess || true,
            metadata: {
                ...request,
                fileType: file.type,
                fileName: file.name,
                tenantCode: request.tenantCode,
                serviceCode: request.serviceCode,
            },
            headers: {
                "Authorization": authorization
            },
            ...options
        });
    }
}

export default ResumableUploadService;